import { makeAutoObservable, when } from 'mobx'

export class NewsletterController {
  isDone = false

  /**
   * @type {NewsletterController}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new NewsletterController()
    }
    return this.instance
  }

  res = {}
  constructor() {
    makeAutoObservable(this)
  }

  success(res) {
    this.res = res
    this.isDone = true
  }

  /** @param {Participant} participant*/
  async show(participant) {
    this.isDone = false

    /** @type HTMLInputElement */
    const emailElement = document.querySelector(
      '#newsletter-modal input[name=EMAIL]'
    )
    emailElement.value = participant.email ?? ''

    /** @type HTMLInputElement */
    const nameElement = document.querySelector(
      '#newsletter-modal input[name=NAME]'
    )
    nameElement.value = participant.name ?? ''

    /** @type HTMLInputElement */
    const positionElement = document.querySelector(
      '#newsletter-modal input[name=POSITION]'
    )
    positionElement.value = participant.position ?? ''

    MicroModal.show('newsletter-modal')
    await when(() => this.isDone)
    return this.res
  }
}
